<template>
    <div id="check">
      <support-dashboard></support-dashboard>
    </div>
</template>

<script>

import SupportDashboard from './SupportDashboard.vue';

export default {
    name: "SupportLayout",
    components: {
        SupportDashboard,
    }
}
</script>

<style>

</style>
